import { useMemo } from "react";
import { useTabContext } from "@/components/layout/tab-context";
import { STANDARD_MODE_ROUTES } from "@/app/router/standard-mode-routes";
import { matchRoutes, parsePath, createPath } from "react-router";

type ParamsRecord = Record<string, string>;

export function useTabParams(): ParamsRecord {
  const { activeTabPath } = useTabContext();

  const { pathname } = useMemo(() => {
    const asString = typeof activeTabPath === "string" ? activeTabPath : createPath(activeTabPath);
    const parsed = parsePath(asString);
    return {
      pathname: parsed.pathname || "/",
    };
  }, [activeTabPath]);

  const routeParams = useMemo<ParamsRecord>(() => {
    const matches = matchRoutes(STANDARD_MODE_ROUTES, { pathname }) || [];
    return matches.reduce((acc, m) => Object.assign(acc, m.params), {} as ParamsRecord);
  }, [pathname]);

  return routeParams;
}
